import {
  DialogTitle as Title,
  Typography,
  styled,
} from '@mui/material';

export const DialogTitle = styled(Title)((props) => {
  const { theme: { palette: { warning } } } = props;
  return {
    color: warning.dark,
    fontSize: '18px',
    lineHeight: '26px',
  };
});

export const DialogSubTitle = styled(Typography)`
  text-align: center;
  line-height: 24px;
  margin-top: 12px;
`;
DialogSubTitle.defaultProps = {
  variant: 'h5',
};

export const SuggestionTitle = styled(Typography)`
  line-height: 24px;
  font-weight: 500;
`;
SuggestionTitle.defaultProps = {
  variant: 'h5',
};

export const SuggestionSection = styled('div')((props) => {
  const { theme: { palette: { background } } } = props;
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '14px 20px',
    borderRadius: '6px',
    margin: '8px 0 16px 0',
    background: background.default,
    '&:last-of-type': {
      marginBottom: 0,
    },
  };
});

export const OptionSection = styled('div')((props) => {
  const { theme: { palette: { text } } } = props;
  return {

    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    color: text.primary,
  };
});

export const OldOptionSection = styled(OptionSection)((props) => {
  const { theme: { palette: { text } } } = props;
  return {
    color: text.secondary,
  };
});

export const OptionName = styled('p')`
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
`;

export const OptionCode = styled('p')`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  margin-top: 2px;
`;

